// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__Pj4hl"};